// Přístupnost — port z portálu (src/helpers/accessibility.ts).
// localStorage flagy + html class toggling. Aplikuje se brzy v App.js, aby
// se UI nezablesklo defaultním stylem před načtením preferencí uživatele.

const STORAGE_KEYS = {
  fontSize: "ct-accessibility-font-size",
  colorContrast: "ct-accessibility-color-contrast",
};

export const isBiggerFontSize = () =>
  typeof window !== "undefined" &&
  window.localStorage.getItem(STORAGE_KEYS.fontSize) === "1";

export const isContrastColor = () =>
  typeof window !== "undefined" &&
  window.localStorage.getItem(STORAGE_KEYS.colorContrast) === "1";

export const setBiggerFontSize = (value) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEYS.fontSize, value ? "1" : "0");
  document.documentElement.classList[value ? "add" : "remove"]("bigger-font-size");
};

export const setContrastColor = (value) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEYS.colorContrast, value ? "1" : "0");
  document.documentElement.classList[value ? "add" : "remove"]("contrast-color");
};

// Aplikuje uložené preference na <html> co nejdřív po startu app.
export const applyStoredAccessibility = () => {
  setBiggerFontSize(isBiggerFontSize());
  setContrastColor(isContrastColor());
};
